import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import MainPage from './components/MainPage';
import Presale from './components/Presale';
import { Navigation } from './components/Navigation';
import StakingPage from './components/StakingPage';
import VestingPage from './components/VestingPage';
import LoginPages from './components/LoginPages';
import SignUpPage from './components/SignUpPage';
import ProfilePage from "./components/ProfilePage";
import { ResetPasswordPage } from "./components/ResetPasswordPage";
import ProjectDetails from "./components/projectdetails";
import Footer from './components/Footer';
import ToySection from './components/ToySection';

function AppRoutes() {
  const location = useLocation();

  // ✅ Hide nav/footer ONLY on home ("/") and projectdetails pages
  const hideNavFooter =
    location.pathname === "/" ||
    location.pathname.startsWith("/projectdetails");

  return (
    <div className="text-white">
      {/* ✅ Show Navigation only if not hidden */}
      {!hideNavFooter && <Navigation />}

      <Routes>
        {/* ✅ Homepage */}
        <Route path="/" element={<MainPage />} />

        {/* ✅ ToySection (nav + footer will show) */}
        <Route path="/ToySection" element={<ToySection />} />

        {/* ✅ Other Pages */}
        <Route path="/presale" element={<Presale />} />
        <Route path="/staking" element={<StakingPage />} />
        <Route path="/vesting" element={<VestingPage />} />
        <Route path="/login" element={<LoginPages />} />
        <Route path="/register" element={<SignUpPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/projectdetails" element={<ProjectDetails />} />
        <Route path="/projectdetails/:id" element={<ProjectDetails />} />
      </Routes>

      {/* ✅ Show Footer only if not hidden */}
      {!hideNavFooter && <Footer />}
    </div>
  );
}

export default function RoutesFile() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}
